import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69369e33"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "length"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "时长：", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["textContent"]
const _hoisted_7 = {
  key: 0,
  class: "length"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "时长：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.mode === 'DESIGN')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx._value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx._value) = $event)),
            size: "default",
            disabled: "",
            type: _ctx.type,
            "start-placeholder": _ctx.placeholder[0],
            "end-placeholder": _ctx.placeholder[1]
          }, null, 8, ["modelValue", "type", "start-placeholder", "end-placeholder"]),
          (_ctx.showLength)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(_ctx.timeLength), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("template", null, [
            (!_ctx.readerMode)
              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                  key: 0,
                  modelValue: _ctx._value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx._value) = $event)),
                  size: "default",
                  clearable: "",
                  "value-format": _ctx.format,
                  type: _ctx.type,
                  "start-placeholder": _ctx.placeholder[0],
                  "end-placeholder": _ctx.placeholder[1]
                }, null, 8, ["modelValue", "value-format", "type", "start-placeholder", "end-placeholder"]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  textContent: _toDisplayString(_ctx._value[0] + ' ~ ' + _ctx._value[1])
                }, null, 8, _hoisted_6))
          ]),
          (_ctx.showLength)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", null, _toDisplayString(_ctx.timeLength), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}